export const ADD_ROOM = 'ADD_ROOM'
export const ADD_ROOMS = 'ADD_ROOMS'
export const LOAD_ROOM = 'LOAD_ROOM'
export const LOAD_ROOMS = 'LOAD_ROOMS'
export const INCREMENT_ROOM_TABLE_NUMBER = 'INCREMENT_ROOM_TABLE_NUMBER'
export const INCREMENT_ROOM_ORDER_COUNT = 'INCREMENT_ROOM_ORDER_COUNT'
export const REMOVE_ROOM_ORDER_COUNT = 'REMOVE_ROOM_ORDER_COUNT'
export const REMOVE_ROOM_TABLE_NUMBER = 'REMOVE_ROOM_TABLE_NUMBER'
export const ADD_ROOM_TABLE_NUMBER = 'ADD_ROOM_TABLE_NUMBER'